<template>
    <div>
  
      <p>
        <h2> 这里查看 按日的留存信息  dailyRetention  </h2>
<h2> 这里查看 按日的留存信息  dailyRetention   先临时放一下, 后续会做成 直接兼容 刷新 或者直接展示";  </h2>
      </p>
    
  
    </div>
  </template>
  <script>



export default {
    data() {
      return  {   r:{
      }}
      },
created:function(){
  //注意回调函数的作用域!!!
  this.$http.get("/da/daily_retention").then( (response)=>  {
this.r = response.data

    console.log(response.data)
  })
},

mounted:function(){
  console.log("/da/daily_retention ==>   完毕")
}

  }
  </script>
  
  <!-- Add "scoped" attribute to limit CSS to this component only -->
  <style scoped>

  </style>
  